import {
    faBan,
    faBuilding,
    faPlus,
    faUserAlt,
    faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import {
    TecnicoNaoCompareceuController,
    VistoriaNaoRealizadaController,
} from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { AlertConfirmation } from "../../../../../../Tools/SweetAlerts";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import CriarAgendamento from "../../../../../../Components/CardsPages/Atendimento/CriarAgendamento";
import { IComponentModal } from "../../../../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../../../../Components/Modais";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IAcoesAcessoUsuario } from "../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";

interface IBotoesManutencaoNaoRealizadaProps {
    emccampMode: string;
    ID_ORGANIZACAO: string;
    AcaoAcessoUsuario: IAcoesAcessoUsuario[] | undefined;
}

export default function BotoesManutencaoNaoRealizada(
    props: IBotoesManutencaoNaoRealizadaProps
) {
    const { Atendimento, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [clienteVizualizaHistorico, setClienteVizualizaHistorico] =
        useState(false);

    const { execute: executarTecnicnoNaoCompareceu, loading } =
        useAsyncCallback(TecnicoNaoCompareceuController);

    const {
        execute: executarVistoriaNaoRealizadaCliente,
        loading: executarVistoriaNaoRealizadaClienteLoading,
    } = useAsyncCallback(VistoriaNaoRealizadaController);

    return (
        <>
            <button
                type="button"
                className="btn btn-sm btn-primary m-1"
                onClick={() => {
                    setShow(true);
                    setModal({
                        headerComponent: "Criar Agendamento",
                        IconHeader: faPlus,
                        Component: () => (
                            <CriarAgendamento
                                updateList={updateAtendimento}
                                setShow={setShow}
                                Atendimento={Atendimento}
                            />
                        ),
                        size: "lg",
                    });
                }}
                disabled={
                    !props.AcaoAcessoUsuario?.find(
                        (acaoFiltrada) => acaoFiltrada.ID_ACAO === 27
                    )?.FL_USUARIO_ACESSA ||
                    AtendimentoDetalhado.FL_SINCRONIZADO === false
                }
            >
                <FontAwesomeIcon icon={faBan} className="mr-2" /> Reparo Não
                Concluido
            </button>

            <button
                type="button"
                className="btn btn-sm  btn-primary m-1"
                disabled={
                    !props.AcaoAcessoUsuario?.find(
                        (acaoFiltrada) => acaoFiltrada.ID_ACAO === 13
                    )?.FL_USUARIO_ACESSA ||
                    executarVistoriaNaoRealizadaClienteLoading ||
                    AtendimentoDetalhado.FL_SINCRONIZADO === false
                }
                onClick={() => {
                    if (Atendimento?.ID_CASO) {
                        executarVistoriaNaoRealizadaCliente(
                            Atendimento.ID_CASO,
                            "Cliente"
                        ).then(() => {
                            updateAtendimento();
                            ReloadHistorico();
                        });
                    }
                }}
            >
                <IconOrSpinner
                    icon={faUserAlt}
                    loadingSize="sm"
                    loading={executarVistoriaNaoRealizadaClienteLoading}
                    className="mr-2"
                />{" "}
                Reparo Não Realizado - Cliente
            </button>

            <button
                type="button"
                className="btn btn-sm  btn-primary m-1"
                onClick={() => {
                    setShow(true);
                    setModal({
                        headerComponent: "Criar Agendamento",
                        IconHeader: faPlus,
                        Component: () => (
                            <CriarAgendamento
                                updateList={updateAtendimento}
                                setShow={setShow}
                                Atendimento={Atendimento}
                            />
                        ),
                        size: "lg",
                    });
                }}
                disabled={
                    !props.AcaoAcessoUsuario?.find(
                        (acaoFiltrada) => acaoFiltrada.ID_ACAO === 12
                    )?.FL_USUARIO_ACESSA ||
                    AtendimentoDetalhado.FL_SINCRONIZADO === false
                }
            >
                <FontAwesomeIcon icon={faBuilding} className="mr-2" /> Reparo
                Não Realizado - Empresa
            </button>

            {props.emccampMode !== props.ID_ORGANIZACAO && (
                <button
                    type="button"
                    className="btn btn-sm  btn-primary m-1"
                    disabled={
                        !props.AcaoAcessoUsuario?.find(
                            (acaoFiltrada) => acaoFiltrada.ID_ACAO === 33
                        )?.FL_USUARIO_ACESSA ||
                        loading ||
                        AtendimentoDetalhado.FL_SINCRONIZADO === false
                    }
                    onClick={() => {
                        if (Atendimento?.ID_CASO) {
                            AlertConfirmation(
                                "Deseja que o cliente possa vizualizar no histórico?",
                                "",
                                "question"
                            ).then((res) => {
                                setClienteVizualizaHistorico(res.isConfirmed);
                            });
                            executarTecnicnoNaoCompareceu(
                                Atendimento.ID_CASO,
                                Atendimento?.ID_ETAPA_TIPO_CASO,
                                clienteVizualizaHistorico
                            ).then(() => {
                                updateAtendimento();
                                ReloadHistorico();
                            });
                        }
                    }}
                >
                    <IconOrSpinner
                        icon={faWrench}
                        loadingSize="sm"
                        loading={loading}
                        className="mr-2"
                    />{" "}
                    Técnico Não Compareceu
                </button>
            )}

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
